// extracted by mini-css-extract-plugin
module.exports = {"memberCardContainer":"CommitteeMemberCard_memberCardContainer__2g1Y5"};